import React from 'react';
import './styles.scss';



const TablePagination = ({data,changePage}) => {

  const qtdInicial = (pageSize, page) => {
    let quantidade = ' ';
    if (pageSize && page) quantidade = (pageSize * page) - (pageSize - 1);
    return ` ${quantidade} `;
  }

  const qtdFinal = (pageSize, page) => {
    let quantidade = ' ';
    if (pageSize && page) {
      if (data.lista.length < pageSize) {
        quantidade = data.totalCount
      } else {
        quantidade = pageSize * page;
      }
    }
    return ` ${quantidade} `;
  }

  return (
    <>
    { data?.pageSize && data?.page && data?.totalCount && data?.totalPages ?
      <div className="PaginationContainer">
        <div>
          Mostrando 
          {qtdInicial(data.pageSize, data.page)}
          até  
          {qtdFinal(data.pageSize, data.page)}
          de {data.totalCount} registros
        </div>
        <div className={`PagesAction`}>
          {
            data.page === 1 ?
            <div className={`controlPage disabled`}> Anterior </div>
            :
            <div className={`controlPage`} onClick={() => changePage(data.page - 1)}>
              Anterior
            </div>
          }
          <div className="numerPage">
            {data.page}
          </div>
          {
            data.page === data.totalPages ?
            <div className={`controlPage disabled`}> Próximo </div>
            :
            <div className={`controlPage`} onClick={() => changePage(data.page + 1)}>
              Próximo
            </div>
          }
        </div>
      </div>
      :
      <div></div>
    }
    </>
  )
}

export default TablePagination;